import { render, staticRenderFns } from "./UpsiRowActions.vue?vue&type=template&id=1ad9aae0"
import script from "./UpsiRowActions.vue?vue&type=script&lang=js"
export * from "./UpsiRowActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports